import ObjectivesColumns from "@/columns/ObjectivesWithoutTasksColumns.js";

export async function GetObjectivesWithoutTasks(thiss) {
  let tableData = [];
  const body = {
    params: {
      responsibleId: thiss.currentUser.EmployeeId
    }
  };
  await thiss.$http
    .get("/api/MessageApi/GetGanttObjectivesWithoutTasks", body)
    .then((resp) => {
      tableData = resp.data;
    });
  return tableData;
}

export const ObjectivesWithoutTasksColumns = ObjectivesColumns;
